module.exports = __webpack_public_path__ + "static/media/export-btn.2c7d5ea0.svg";